var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c("gg-card-header", [
                    _vm._v(" DKIM - " + _vm._s(_vm.domain) + " ")
                  ]),
                  _c(
                    "gg-card-text",
                    [
                      _vm.pendingDetails
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex justify-center align-items-center pa-10",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                      size: "80"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : !_vm.hasResult
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        type: "error",
                                        text: "",
                                        dense: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " We couldn't load the DKIM details for " +
                                          _vm._s(_vm.domain) +
                                          ". "
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            small: "",
                                            tertiary: ""
                                          },
                                          on: {
                                            click: _vm.loadDetails
                                          }
                                        },
                                        [_vm._v("Try again")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _vm.dkimData.state === "MISSING"
                                    ? _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            type: "info",
                                            dense: ""
                                          }
                                        },
                                        [
                                          _vm._v(" A “DKIM” record does "),
                                          _c("b", [_vm._v("not")]),
                                          _vm._v(
                                            " exist for this domain. To properly configure your DKIM key, the record must use this server’s DKIM key. "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  Boolean(!_vm.nsData.local_authority)
                                    ? _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            type: "error",
                                            dense: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            ' This system does not control DNS for the "' +
                                              _vm._s(_vm.domain) +
                                              '" domain. You can install the suggested “DKIM” record locally. However, this server is not the authoritative nameserver. If you install this record, this change will not be effective. Contact the person responsible for the nameservers and request that they update the “DKIM” record with the following: '
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "font-weight-bold",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [_vm._v(" Suggested “DKIM” (TXT) Record ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "6"
                                  }
                                },
                                [
                                  _c("b", [_vm._v("Name")]),
                                  _c("p", [_vm._v(_vm._s(_vm.dkimData.domain))])
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "6"
                                  }
                                },
                                [
                                  _c("b", [_vm._v("Value")]),
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.dkimData.expected))
                                  ])
                                ]
                              ),
                              _c("v-col", {
                                attrs: {
                                  cols: "12"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c("gg-card-header", [
                    _vm._v(" SPF - " + _vm._s(_vm.domain) + " ")
                  ]),
                  _c(
                    "gg-card-text",
                    [
                      _vm.pendingDetails
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex justify-center align-items-center pa-10",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                      size: "80"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : !_vm.hasResult
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        type: "error",
                                        text: "",
                                        dense: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " We couldn't load the SPF details for " +
                                          _vm._s(_vm.domain) +
                                          ". "
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            small: "",
                                            tertiary: ""
                                          },
                                          on: {
                                            click: _vm.loadDetails
                                          }
                                        },
                                        [_vm._v("Try again")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            [
                              _vm.spfData.state !== "VALID"
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            type: "info",
                                            dense: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " “SPF” is not properly configured for this domain. "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.spfData.state !== "VALID"
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "py-0",
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " To properly configure your SPF record, you must include the following mechanisms: "
                                      ),
                                      _c("code", [
                                        _vm._v(_vm._s(_vm.spfData.expected))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              Boolean(!_vm.nsData.local_authority)
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            type: "error",
                                            dense: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            ' This system does not control DNS for the "' +
                                              _vm._s(_vm.domain) +
                                              '" domain and the system did not find any authoritative nameservers for this domain. You can install the suggested “SPF” record locally. However, this server is not the authoritative nameserver. If you install this record, this change will not be effective. Contact your domain registrar to verify this domain’s registration. '
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "font-weight-bold",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [_vm._v(" Suggested “SPF” (TXT) Record ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "6"
                                  }
                                },
                                [
                                  _c("b", [_vm._v("Name")]),
                                  _c("p", [_vm._v(_vm._s(_vm.spfData.domain))])
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    md: "6"
                                  }
                                },
                                [
                                  _c("b", [_vm._v("Value")]),
                                  _c("p", [_vm._v(_vm._s(_vm.spfExpected))])
                                ]
                              ),
                              _c("v-col", {
                                attrs: {
                                  cols: "12"
                                }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }